import {
  yesNoSchema,
  yesNoUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { isYes } from '../../../utils/helpers';
import { AdditionalMarriagesAlert } from '../../../components/FormAlerts';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['household-additional-marriages-title']),
    claimantHasAdditionalMarriages: yesNoUI({
      title: content['household-additional-marriages-question'],
    }),
    additionalMarriagesAlert: {
      'ui:description': AdditionalMarriagesAlert,
      'ui:options': {
        hideIf: formData => !isYes(formData?.claimantHasAdditionalMarriages),
        displayEmptyObjectOnReview: true,
      },
    },
  },
  schema: {
    type: 'object',
    required: ['claimantHasAdditionalMarriages'],
    properties: {
      claimantHasAdditionalMarriages: yesNoSchema,
      additionalMarriagesAlert: {
        type: 'object',
        properties: {},
      },
    },
  },
};
